/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)


// axios
import axios from "./axios.js"
Vue.prototype.$http = axios


// Theme Configurations
import '../themeConfig.js'

// Firebase
import '@/firebase/firebaseConfig'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

// ■ add npm
// VeeValidate
import VeeValidate, {Validator} from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja'
Validator.localize('ja', ja)
Vue.use(VeeValidate, { locale: ja })

// infinite loading
import InfiniteLoading from 'vue-infinite-loading'
Vue.use(InfiniteLoading)

// clipbord copy
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


// ■ add derective
/*
Vue.directive('infinite-scroll', {
    inserted: function(el, binding) {
        let f = function(evt) {
            if (binding.value(evt, el)) {
                window.removeEventListener('scroll', f)
            }
        }
        window.addEventListener('scroll', f)
    }
})
*/
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
HighchartsMore(Highcharts);
Highcharts.setOptions({
    lang: {
        decimalPoint: '.',
        //drillUpText: 'Back',
        //noData: "Check your options please",
        //resetZoom: 'Reset',
        thousandsSep: ','
    }
});
import HighchartsVue from 'highcharts-vue'
Vue.use(HighchartsVue)

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.3, // 事前ロードする高さの割合指定
  //error: ‘images/error.png’, // エラー時に表示する画像指定
  //loading: ‘images/loading.gif’, // ロード中に表示する画像指定
  attempt: 1 // ロード失敗した時のリトライの上限指定
})

//import validbarcode from 'barcode-validator'

// fontawesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
library.add(fas, far, fab)
//library.add(faCoffee)
Vue.component('font-awesome-icon', FontAwesomeIcon)

import Cleave from 'vue-cleave-component'
Vue.use(Cleave)


Vue.prototype.$EventBus = new Vue() // EventBusの宣言

//Vue.config.productionTip = false

// ■ add filter
Vue.filter('addComma', function (val) {
  return val.toLocaleString()
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
